const configurationRoutes = (prop) => [
    {
        path: 'add-class',
        name: prop + '.add_class',
        meta: { auth: true },
        component: () => import('../pages/add-class/List.vue')
    },
    {
        path: 'committee-name',
        name: prop + '.committee_name',
        meta: { auth: true },
        component: () => import('../pages/committee-name/List.vue')
    },
    {
        path: 'assessment-crieteria',
        name: prop + '.assessment_tools',
        meta: { auth: true },
        component: () => import('../pages/assessment-tools/List.vue')
    },
    {
        path: 'library-book',
        name: prop + '.library_book',
        meta: { auth: true },
        component: () => import('../pages/library-book/List.vue')
    },
    {
        path: 'individual-assessment',
        name: prop + '.individual_assessment',
        meta: { auth: true },
        component: () => import('../pages/individual-assessment/List.vue')
    },
    {
        path: 'therapy-center',
        name: prop + '.therapy_center',
        meta: { auth: true },
        component: () => import('../pages/therapy-center/List.vue')
    },
    {
        path: 'hostel',
        name: prop + '.hostel',
        meta: { auth: true },
        component: () => import('../pages/hostel/List.vue')
    },
    {
        path: 'individual-lesson-plan',
        name: prop + '.individual_lesson_plan',
        meta: { auth: true },
        component: () => import('../pages/individual-lesson-plan/List.vue')
    },
    {
        path: 'course-name',
        name: prop + '.course_name',
        meta: { auth: true },
        component: () => import('../pages/course-name/List.vue')
    },
    {
        path: 'training-name',
        name: prop + '.training_name',
        meta: { auth: true },
        component: () => import('../pages/training-name/List.vue')
    },
    {
        path: 'exam-type',
        name: prop + '.exam-type',
        meta: { auth: true },
        component: () => import('../pages/exam-type/List.vue')
    },
    {
        path: 'report-heading',
        name: prop + '.report_heading',
        meta: { auth: true },
        component: () => import('../pages/report-heading/List.vue')
    },
    {
        path: 'curricular-type',
        name: prop + '.curricular_type',
        meta: { auth: true },
        component: () => import('../pages/curricular-type/List.vue')
    },
    {
        path: 'curricular-activities',
        name: prop + '.curricular_activities',
        meta: { auth: true },
        component: () => import('../pages/curricular-activities/List.vue')
    },
    {
        path: 'designation',
        name: prop + '.designation',
        meta: { auth: true },
        component: () => import('../pages/designation/List.vue')
    },
    {
        path: 'pay-grade',
        name: prop + '.pay-grade',
        meta: { auth: true },
        component: () => import('../pages/pay-grade/List.vue')
    },
    {
        path: 'grade',
        name: prop + '.grade',
        meta: { auth: true },
        component: () => import('../pages/grade/List.vue')
    },
    {
        path: 'iep-slot',
        name: prop + '.iep_slot',
        meta: { auth: true },
        component: () => import('../pages/iepslot/List.vue')
    },
    {
        path: 'received-notifications',
        name: prop + '.received_notifications',
        meta: { auth: true },
        component: () => import('../pages/received-notifications/List.vue')
    },
    {
        path: 'activity-log',
        name: prop + '.activity_log',
        meta: { auth: true },
        component: () => import('../pages/activity-log/List.vue')
    }
]
const routes = [{
    path: '/disability-school-service/configuration',
    name: 'disability_school_service.configuration',
    component: () => import('@/layouts/DisabilitySchoolLayout.vue'),
    meta: { auth: true },
    children: configurationRoutes('disability_school_service.configuration')
}]
export default routes
